"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");

var prop_types_1 = require("prop-types");

require("./index.css");

var MiniLoaderIcon = function (_a) {
  var className = _a.className;
  return (0, jsx_runtime_1.jsx)("svg", __assign({
    className: "spinner " + className,
    width: "40px",
    height: "40px",
    viewBox: "0 0 66 66",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: (0, jsx_runtime_1.jsx)("circle", {
      className: "path",
      fill: "none",
      strokeWidth: "6",
      strokeLinecap: "square",
      cx: "33",
      cy: "33",
      r: "26"
    }, void 0)
  }), void 0);
};

var MiniLoader = function (_a) {
  var className = _a.className,
      dataTestId = _a.dataTestId,
      isVisible = _a.isVisible;
  return isVisible ? (0, jsx_runtime_1.jsx)("div", __assign({
    className: "mini-loader-contain",
    "data-testid": dataTestId
  }, {
    children: (0, jsx_runtime_1.jsx)("div", __assign({
      className: "mini-loader-holder"
    }, {
      children: (0, jsx_runtime_1.jsx)(MiniLoaderIcon, {
        className: {
          className: className
        }
      }, void 0)
    }), void 0)
  }), void 0) : null;
};

MiniLoader.propTypes = {
  dataTestId: prop_types_1.string,
  isVisible: prop_types_1.bool,
  className: prop_types_1.string
};
MiniLoader.defaultProps = {
  dataTestId: 'Loading',
  isVisible: true,
  className: 'mini-loader-spinner'
};
exports.default = MiniLoader;